export default ({ request }) => ({
  ecomAmzVcOrderFilesListApi(data = {}) {
    return request({
      url: '/ecom/amz/vc/order/files/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzVcOrderFilesUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/vc/order/files/upload',
      method: 'POST',
      data,
    })
  },
  ecomAmzVcOrderFilesDelApi(data = {}) {
    return request({
      url: '/ecom/amz/vc/order/files/del',
      method: 'POST',
      data,
    })
  },
})
